import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Button,
  Popper,
  Paper,
  ClickAwayListener,
  MenuItem,
  TextField,
  Autocomplete,
  InputAdornment,
  Stack,
  Chip,
  Menu,IconButton, ListItemText, ListItemSecondaryAction
} from "@mui/material";
import { debounce } from "lodash";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import HomeIcon from "@mui/icons-material/Home";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CloseIcon from '@mui/icons-material/Close';
import httpCommon from '../../http-common';



const AdvancedSearch = ({ locations = [], propertyTypes = [], budgets = [], onSearch,defaultValues = {}  }) => {
  const [formData, setFormData] = useState({
  
        location: defaultValues.location || [],
        projectTitle: defaultValues.projectTitle || [],
        propertyType: defaultValues.propertyType || [],
        minBudget: defaultValues.minBudget || "",
        maxBudget: defaultValues.maxBudget || "",
  });

const getAddress = (item) => {
  return (
    item.ltg_det_address ||
    item.ltg_det_plot_address ||
    item.ltg_det_comm_prop_address ||
    item.ltg_det_penthouses_address ||
    item.ltg_det_row_house_address ||
    item.ltg_det_villaments_address ||
    item.ltg_det_villa_address ||
    ""
  );
};
const getPropertyCoordinates = (item) => {
  if (!item) return null;

  let lat;
  let lng;

  switch (item.ltg_type) {
    case "Plots":
      lat = item.ltg_det_plot_latitude;
      lng = item.ltg_det_plot_longitude;
      break;

    case "RowHouses":
      lat = item.ltg_det_row_house_latitude;
      lng = item.ltg_det_row_house_longitude;
      break;

    case "CommercialProperties":
      lat = item.ltg_det_comm_prop_latitude;
      lng = item.ltg_det_comm_prop_longitude;
      break;

    case "Villaments":
      lat = item.ltg_det_villaments_latitude;
      lng = item.ltg_det_villaments_longitude;
      break;

    case "PentHouses":
      lat = item.ltg_det_penthouses_latitude;
      lng = item.ltg_det_penthouses_longitude;
      break;

    default:
      // Apartments / Villas
      lat = item.ltg_det_latitude;
      lng = item.ltg_det_longitude;
      break;
  }

  lat = Number(lat);
  lng = Number(lng);

  if (Number.isNaN(lat) || Number.isNaN(lng)) {
    return null;
  }

  return { lat, lng };
};

  const [budgetOpen, setBudgetOpen] = useState(false); // open by default
  const budgetRef = useRef(null);
  const [showAllTags, setShowAllTags] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
 const [allProperties, setAllProperties] = useState([]);
 const [selectedOptions, setSelectedOptions] = useState([]);

  // Update formData when defaultValues change (when navigating from home page)
    // useEffect(() => {
    //     if (defaultValues && Object.keys(defaultValues).length > 0) {
    //         setFormData({
    //             location: defaultValues.location || [],
    //             projectTitle: defaultValues.projectTitle || [],
    //             propertyType: defaultValues.propertyType || [],
    //             minBudget: defaultValues.minBudget || "",
    //             maxBudget: defaultValues.maxBudget || "",
    //         });
    //     }
    // }, [defaultValues]);
    useEffect(() => {
  if (defaultValues && Object.keys(defaultValues).length > 0) {
    setFormData({
      location: defaultValues.location || [],
      projectTitle: defaultValues.projectTitle || [],
      propertyType: defaultValues.propertyType || [],
      minBudget: defaultValues.minBudget || "",
      maxBudget: defaultValues.maxBudget || "",
      searchLat: defaultValues.searchLat || null,
      searchLng: defaultValues.searchLng || null,
    });

    // Restore selected Location + Project chips
    const selected = [
      ...(defaultValues.location || []).map((loc) => ({
        type: "Location",
        label: loc,
        value: loc,
      })),

      ...(defaultValues.projectTitle || []).map((title) => ({
        type: "Project",
        label: title,
        value: title,
      })),
    ];

    setSelectedOptions(selected);
  }
}, [defaultValues]);

useEffect(() => {
  const loadProperties = async () => {
    try {
      setLoading(true);

      const res = await httpCommon.get(`/list`);

      setAllProperties(res.data.data || []);

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  loadProperties();
}, []);

  // Debounced API call
const fetchLocations = async (value) => {

  try {
    setLoading(true);

    const dataArray = allProperties;

    const searchValue = value.toLowerCase().trim();

    const keywords = searchValue.split(/\s+/);

   const filteredResults = dataArray.filter((item) => {

  const projectName = (
    item.ltg_projectName || ""
  ).toLowerCase();

  const address = (
    getAddress(item) || ""
  ).toLowerCase();

  return (
    item.ltg_det_sold_type !== "1" &&
    keywords.every(
      (keyword) =>
        projectName.includes(keyword) ||
        address.includes(keyword)
    )
  );

});

    const formatted = filteredResults.flatMap((item) => {

      const arr = [];

      const address = getAddress(item);

      // LOCATION
      if (
        address &&
        address.toLowerCase().includes(searchValue)
      ) {

        arr.push({
          type: "Location",
          label: value,
          subLabel: item.ltg_regions || "",
          value: address,
          fullData: item,
        });

      }

      // PROJECT
      if (item.ltg_projectName) {

        arr.push({
          type: "Project",
          label: item.ltg_projectName,
          subLabel: address || "",
          value: item.ltg_projectName,
          fullData: item,
        });

      }

      return arr;

    });

    // REMOVE DUPLICATES
    const uniqueFormatted = [];
    const seen = new Set();

    formatted.forEach((item) => {

      const key = `${item.type}-${item.value}`;

      if (!seen.has(key)) {

        seen.add(key);

        uniqueFormatted.push(item);

      }

    });

   setOptions(
  uniqueFormatted.slice(0, 15)
);

  } catch (err) {

    console.error(err);

  } finally {

    setLoading(false);

  }

};

useEffect(() => {

  const timer = setTimeout(() => {

   if (
    inputValue.trim().length >= 1 &&
   allProperties.length > 0
    ) {

      // CLEAR OLD OPTIONS
      setOptions([]);

      fetchLocations(inputValue);

    } else {

      setOptions([]);

    }

  }, 200);

  return () => clearTimeout(timer);

}, [inputValue, allProperties]);


 const handleBudgetSelect = (type, value) => {
  if (type === "minBudget") {
    setFormData((prev) => ({
      ...prev,
      minBudget: value,
      maxBudget: "", // reset maxBudget on minBudget change
    }));
  } else {
    setFormData((prev) => ({
      ...prev,
      maxBudget: value,
    }));
    setBudgetOpen(false); // auto-close after max selection
  }
};

const formatBudget = (value) => {
  if (!value) return "";

  if (value >= 100) {
    return `${value / 100} Cr`;
  }

  return `${value} LAC`;
};

const displayBudgetLabel = () => {
  const { minBudget, maxBudget } = formData;
  if (minBudget && maxBudget)
    return `${formatBudget(minBudget)} - ${formatBudget(maxBudget)}`;
  if (minBudget) return `Min ${formatBudget(minBudget)}`;
  if (maxBudget) return `Max ${formatBudget(maxBudget)}`;
  return "Budget";
};

//  generate budgets in 5 Lac gap (example: 5L, 10L, 15L ... 95L, 1Cr, 1.05Cr ...)
const budgets5Gap = React.useMemo(() => {
  const list = [];

  // 5 LAC gap: 5L to 1 Cr
  for (let i = 5; i <= 100; i += 5) {
    list.push(i);
  }

  // 10 LAC gap: 1 Cr to 5 Cr
  for (let i = 110; i <= 500; i += 10) {
    list.push(i);
  }

  // 25 LAC gap: 5 Cr to 10 Cr
  for (let i = 525; i <= 1000; i += 25) {
    list.push(i);
  }

  // 50 LAC gap: 10 Cr to 25 Cr
  for (let i = 1050; i <= 2500; i += 50) {
    list.push(i);
  }

  // 1 Cr gap: 25 Cr to 100 Cr
  for (let i = 2600; i <= 10000; i += 100) {
    list.push(i);
  }

  return list;
}, []);

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={2}
      sx={{
        borderRadius: "30px",
        bgcolor: "#fff",
        boxShadow: 2,
        p: 2,
        flexWrap: { xs: "wrap", sm: "nowrap" },
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
    
<Autocomplete
  multiple
  freeSolo
  ListboxProps={{
  style: {
    maxHeight: 400,
    overflow: "auto",
  },
}}
 options={(() => {
  const uniqueOptions = [];
  const seen = new Set();

  options.forEach((option) => {
    const key = `${option.type}-${option.label}`;

    if (!seen.has(key)) {
      seen.add(key);
      uniqueOptions.push(option);
    }
  });

  return uniqueOptions;
})()}
 value={selectedOptions}
  groupBy={(option) => option.type}
  loading={loading}
  loadingText="Searching..."
  noOptionsText={
  inputValue
    ? `Search "${inputValue}"`
    : "No Data"
  }
 getOptionLabel={(option) => {
  if (typeof option === "string") return option;

  return option.label || "";
}}
  filterOptions={(x) => x}
onChange={(e, newValue) => {
  setSelectedOptions(
    newValue.filter((item) => typeof item !== "string")
  );
  const selectedLocations = [];
  const selectedProjects = [];

  let searchLat = null;
  let searchLng = null;

  newValue.forEach((item) => {

    // Ignore manually typed text
    if (typeof item === "string") {
      return;
    }

    // LOCATION
    if (item.type === "Location") {
      if (!selectedLocations.includes(item.label)) {
        selectedLocations.push(item.label);
      }

      const coordinates = getPropertyCoordinates(item.fullData);

      if (coordinates) {
        searchLat = coordinates.lat;
        searchLng = coordinates.lng;
      }
    }

    // PROJECT
    if (item.type === "Project") {
      if (!selectedProjects.includes(item.value)) {
        selectedProjects.push(item.value);
      }

      const coordinates = getPropertyCoordinates(item.fullData);

      if (coordinates) {
        searchLat = coordinates.lat;
        searchLng = coordinates.lng;
      }
    }
  });

  const updatedData = {
    ...formData,
    location: selectedLocations,
    projectTitle: selectedProjects,
    searchLat,
    searchLng,
  };

  setFormData(updatedData);

  //console.log("SEARCH FORM DATA____", updatedData);
}}
  onInputChange={(event, newInputValue, reason) => {
    if (reason !== "reset") setInputValue(newInputValue);
  }}
  filterSelectedOptions
  renderTags={(value, getTagProps) => {
    if (!value.length) return null;

    const first = value[0];
    const rest = value.slice(1);

    const handleMoreClick = (event) => setAnchorEl(event.currentTarget);
    const handleClearAll = () => {
      setFormData((prev) => ({
        ...prev,
        projectTitle: [],
      }));
      setAnchorEl(null);
      setShowAllTags(false);
    };

    return [
      <Chip
      label={
          typeof first === "string"
            ? first
            : first.type === "Location"
            ? first.label
            : first.value || ""
        }
        {...getTagProps({ index: 0 })}
        key={typeof first === "string" ? first : first.value}
        sx={{ mr: 1 }}
      />,
      rest.length > 0 && (
        <Chip
          label={`+${rest.length}`}
          onClick={handleMoreClick}
          key="more-chip"
          sx={{ backgroundColor: "#f0f0f0", cursor: "pointer" }}
        />
      ),
      <Menu
        key="dropdown-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        PaperProps={{ style: { maxHeight: 300, minWidth: 220 } }}
      >
        {rest.map((option, idx) => (
          <MenuItem key={idx} divider>
          <ListItemText
            primary={
              typeof option === "string"
                ? option
                : option.type === "Location"
                ? option.label
                : option.value || ""
            }
          />
          </MenuItem>
        ))}
        {rest.length > 0 && (
          <MenuItem
            onClick={handleClearAll}
            sx={{
              color: "red",
              fontWeight: "bold",
              borderTop: "1px solid #ddd",
            }}
          >
            Clear All
          </MenuItem>
        )}
      </Menu>,
    ];
  }}
  
renderOption={(props, option) => {
  return (
    <li
      {...props}
      style={{
        borderBottom: "1px solid #f1f1f1",
        padding: "10px 14px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >

        {/* Type */}
        <span
          style={{
            fontSize: "11px",
            color: "#2196F3",
            fontWeight: 700,
            textTransform: "uppercase",
            marginBottom: "2px",
          }}
        >
         {option.type === "Location" ? "📍 Location" : "🏢 Project"}
        </span>

        {/* Main Label */}
        <span
          style={{
            fontSize: "14px",
            fontWeight: 600,
            color: "#222",
          }}
        >
          {option.label}
        </span>

        {/* Subtitle */}
        {option.subLabel && (
          <span
            style={{
              fontSize: "12px",
              color: "#777",
              marginTop: "2px",
            }}
          >
            {option.subLabel}
          </span>
        )}
      </Box>
    </li>
  );
}}
  renderInput={(params) => (
    <TextField
      {...params}
      variant="standard"
      placeholder="Enter City, Locality, Project"
      InputProps={{
        ...params.InputProps,
        disableUnderline: true,
        startAdornment: (
          <>
            <InputAdornment position="start">
              <LocationOnIcon color="error" />
            </InputAdornment>
            {params.InputProps.startAdornment}
          </>
        ),
      }}
      sx={{ minWidth: 300 }}
      onKeyDown={(e) => {
        // if (e.key === "Enter") {
        //   e.preventDefault();

        //   const trimmedInput = inputValue.trim();

        //   let updatedProjectTitle = [...formData.projectTitle];

        //   if (
        //     trimmedInput &&
        //     !updatedProjectTitle.some(
        //       (item) =>
        //         item.toLowerCase() ===
        //         trimmedInput.toLowerCase()
        //     )
        //   ) {
        //     updatedProjectTitle.push(trimmedInput);
        //   }

        //   onSearch({
        //     ...formData,
        //     projectTitle: updatedProjectTitle,
        //   });
        // }
        if (e.key === "Enter") {
          e.preventDefault();

          onSearch({
            ...formData,
          });
        }
      }}
    />
  )}
  sx={{ maxWidth: 400 }}
/>


      {/* Property Type Dropdown */}
    <TextField
    select
    variant="standard"
    SelectProps={{
      multiple: true,
      displayEmpty: true,
      renderValue: (selected) => {
        if (!selected.length) return <span style={{ color: '#aaa' }}>Property Type</span>;
        const first = selected[0];
        const rest = selected.length - 1;
        return rest > 0 ? `${first} +${rest}` : first;
      },
    }}
  InputProps={{
    disableUnderline: true,
    startAdornment: (
      <InputAdornment position="start">
        <HomeIcon color="error" />
      </InputAdornment>
    ),
  }}
  value={formData.propertyType}
  onClick={(e) => e.stopPropagation()} // prevent double open
  sx={{ minWidth: 150 }}
>
  <MenuItem disabled value="">
    Property Type
  </MenuItem>

  {propertyTypes.map((type, index) => (
    <MenuItem
      key={index}
      value={type}
      onClick={(e) => {
        e.stopPropagation(); // prevent double toggle
        setFormData((prev) => {
          const exists = prev.propertyType.includes(type);
          const newTypes = exists
            ? prev.propertyType.filter((t) => t !== type)
            : [...prev.propertyType, type];
          return {
            ...prev,
            propertyType: newTypes,
          };
        });
      }}
    >
      <input
        type="checkbox"
        checked={formData.propertyType.includes(type)}
        readOnly
        style={{ marginRight: 8 }}
      />
      {type}
    </MenuItem>
  ))}
</TextField>




      {/* Budget Dropdown Trigger */}
      <Box ref={budgetRef}>
        <Button
          variant="text"
          onClick={() => setBudgetOpen((prev) => !prev)}
          startIcon={<CurrencyRupeeIcon color="error" />}
          sx={{
            color: "#333",
            textTransform: "none",
            borderRadius: "20px",
          }}
        >
          {displayBudgetLabel()}
        </Button>
        
        
        {/* Budget Dropdown Content */}
   <Popper
      open={budgetOpen}
      anchorEl={budgetRef.current}
      placement="bottom-start"
      disablePortal
      modifiers={[
        {
          name: "preventOverflow",
          options: {
            altBoundary: true,
            tether: false,
            rootBoundary: "viewport",
            padding: 8,
          },
        },
      ]}
      style={{ zIndex: 1300 }} 
  >
  <ClickAwayListener onClickAway={() => setBudgetOpen(false)}>
    <Paper sx={{ p: 2, borderRadius: 2, minWidth: 300, height:200, overflow:"auto" }}>
      <Stack direction="row" spacing={4} className="hhhh">

        {/* Min Price */}
      <Box sx={{ flex: 1 }}>
      <Box fontWeight="bold" mb={1}>Min Price</Box>
        <Stack spacing={1}>
          {budgets5Gap.map((price, i) => {
            const label =
              price > 75
                ? `₹${(price / 100).toFixed(2)} Cr`
                : `₹${price} LAC`;

            return (
              <Button
                key={`min-${i}`}
                onClick={() => handleBudgetSelect("minBudget", price)}
                size="small"
                fullWidth
                sx={{
                  justifyContent: "flex-start",
                  textTransform: "none",
                   fontSize: 14,
                  color: "#444",
                  "&:hover": { bgcolor: "#f5f5f5" },
                  bgcolor:
                    formData.minBudget === price ? "#f0f0f0" : "transparent",
                }}
              >
                {label}
              </Button>
            );
          })}
        </Stack>
      </Box>


        {/* Max Price */}
        {formData.minBudget && (
          <Box sx={{ flex: 1 }}>
            <Box fontWeight="bold" mb={1}>Max Price</Box>
            <Stack spacing={1}>
              {budgets5Gap
                .filter((price) => price > parseInt(formData.minBudget))
                .map((price, i) => (
                  <Button
                    key={`max-${i}`}
                    onClick={() => handleBudgetSelect("maxBudget", price)}
                    size="small"
                    fullWidth
                    sx={{
                      justifyContent: "flex-start",
                      textTransform: "none",
                      fontSize: 14,
                      color: "#444",
                      "&:hover": { bgcolor: "#f5f5f5" },
                      bgcolor:
                        formData.maxBudget === price ? "#f0f0f0" : "transparent",
                    }}
                  >
                    ₹{price >= 100 ? `${price / 100} Cr` : `${price} LAC`}
                  </Button>
                ))}
            </Stack>
          </Box>
        )}
      </Stack>
    </Paper>
  </ClickAwayListener>
</Popper>


      </Box>

      {/* Search Button */}
      <Button
        variant="contained"
        sx={{
          flexShrink: 0,
          whiteSpace: "nowrap", 
          
          mt: { xs: 2, sm: 0 },
          borderRadius: "30px",
          px: 3,
          bgcolor: "#2196F3",
          color: "#fff",
          "&:hover": {
            bgcolor: "#1976D2",
          },
        }}
        // onClick={() => {
        // const trimmedInput = inputValue.trim();

        // let updatedProjectTitle = [...formData.projectTitle];

        // if (
        //   trimmedInput &&
        //   !updatedProjectTitle.some(
        //     (item) =>
        //       item.toLowerCase() ===
        //       trimmedInput.toLowerCase()
        //   )
        // ) {
        //   updatedProjectTitle.push(trimmedInput);
        // }

        // onSearch({
        //   ...formData,
        //   projectTitle: updatedProjectTitle,
        // });
        // }}
        onClick={() => {
          onSearch({
            ...formData,
          });
        }}
      >
        🔍 SEARCH
      </Button>
    </Stack>
  );
};

export default AdvancedSearch;
